import { useEffect, useRef } from 'react';
import styles from './slider-thumbs.module.sass';
import { Carousel2 } from '../../Carousel2';

interface SliderThumbs {
    currentSlide: number;
    images: string[];
    handleCardClick: (index: number) => void;
    dir: 'rtl' | 'ltr';
    live?: string[];
}

function SliderThumbs({ currentSlide, images, handleCardClick, dir = 'rtl', live }: SliderThumbs) {
    const swiperRef = useRef<any>(null);

    const swiperSettings = {
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        centeredSlides: true,
        virtual: false,
        speed: 200,
        navigation: false,
        slideNextClass: 'slide-next',
        slideActiveClass: 'slide-active',
        dir,
        breakpoints: {
            924: {
                centeredSlides: false,
            },
        },
    };

    useEffect(() => {
        const swiper = swiperRef.current?.swiper;

        if (swiper) {
            swiper.slideTo(currentSlide);
        }
    }, [currentSlide]);

    return (
        <div className={styles.thumbs}>
            <Carousel2 swiperSettings={swiperSettings} ref={swiperRef} dir={dir}>
                {images.map((img, index) => {
                    return (
                        <div
                            onClick={() => handleCardClick(index)}
                            key={`slide-thumb-${index}`}
                            className={`${styles['swiper-slide']} ${currentSlide === index ? 'thumb-active' : ''} ${
                                currentSlide - 1 === index ? styles['prev-slide'] : ''
                            } ${currentSlide - 2 === index ? styles['prev-prev-slide'] : ''}`}
                        >
                            <div className={styles.frame}>
                                {img && <img data-testid={`thumbnail-${index}`} src={img} alt="Video thumbnail" />}
                                {live?.[index] && currentSlide !== index && (
                                    <span className={styles.live}>{live[index]}</span>
                                )}
                            </div>
                        </div>
                    );
                })}
            </Carousel2>
        </div>
    );
}

export default SliderThumbs;
